/**
 * @desc 采购比例分配修改
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierPurchaseRatioUpdateRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/updatePurchaseRatio`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
